import { QUERY_KEYS } from "@forwardflow/helpers/utils/constants"
import CampaignService from "@forwardflow/services/CampaignService"
import useSWR from "swr"

export const useGetVoices = () => {
   return useSWR(
      [QUERY_KEYS.GET_VOICES],
      () => CampaignService.getVoices()
   )
}
